// extracted by mini-css-extract-plugin
export default {"mdiv":"ProWork_mdiv__OqtYb","pwH3":"ProWork_pwH3__wRmQg","imgPw":"ProWork_imgPw__DtQ+H","LinkP":"ProWork_LinkP__c3A5C","LinkDiv":"ProWork_LinkDiv__oJHO2"};